import moment from 'moment-timezone'
import axios from '@/utils/axios_iface'
import { getBaseUrl } from '@/utils/main_utils'
import Vue from 'vue'
import * as CONST from '@/constants.js'
import * as utils from '@/utils/main_utils'

export default {
  state: {
    selectedBusinessType: undefined,
    selectedType: 'all',
    selectedDelivery: 'CRM',
    selectedBusinessTypeShouldHaveKitchen: false,
    selectedKitchenType: '',
    selectedRadis: 2,
    selectedPriceRange: undefined,
    selectedBrandId: undefined,
    dineinAreas: undefined,
    dineinTables: undefined,
    dineinCovers: undefined,
    floorTable: { table_id: undefined, floor_id: undefined },
    openModifier: false,
    productDetailsPage: false,
    productId: false,
    openModifierMobile: false,
    searchTerm: '',
    quickView: { items: false, categories: false, selected_cat: false },
    offer: false,
    quickLoader: false,
    customization_default: {
      colors: {},
      topbar_availability: true,
      topbar_logo_position: true,
      slider_availability: true,
      slider_multiimage: true,
      title_availability: true,
      app_section_availability: true,
      app_section_image_order: true,
      footer_main_availability: true,
      footer_sub_availability: true,
    },
    dineinNotify: undefined,
    customization: {},
    customizationLocal: {},
    customizationIsSaving: false,
  },
  getters: {
    customizationIsSaving: state => state.customizationIsSaving,
    defaultSelectedCover: state => {
      if (state.dineinCovers && state.dineinCovers.length) {
        return state.dineinCovers[0]
      }
      return undefined
    },
    productSlug: state => state.productId,
    isCustomizationSaved: state => {
      return (
        JSON.stringify(state.customizationLocal) ===
        JSON.stringify(state.customization)
      )
    },

    dineinNotificationUpdate: state => state.dineinNotify,
    isFloorTableAvailable: state => state.floorTable,
    dineinArea: state => area_id =>
      state.dineinAreas ? state.dineinAreas._id[area_id] : undefined,
    dineinTable: state => table_id => {
      let table_data = undefined
      if (state.dineinTables) {
        state.dineinTables.forEach(table => {
          if (table._id === table_id) {
            table_data = table
          }
        })
      }
      return table_data
    },

    isCustomizationLoaded: state => {
      return Object.keys(state.customizationLocal).length > 0
    },
    customization: state => state.customization,
    customization_default: state => {
      Vue.set(
        state.customization_default,
        'colors',
        JSON.stringify(state.default_colors)
      )
      return state.customization_default
    },
    customizationLocal: state => state.customizationLocal,
    getSelectedDelivery: state => state.selectedDelivery,
    getSelectedBusinessType: state => state.selectedBusinessType,
    getSelectedKitchenType: state => state.selectedKitchenType,
    getSelectedPriceRange: state => state.selectedPriceRange,
    getSelectedBrandId: state => state.selectedBrandId,
    getStoreByBrandStoreId: (state, getters) => (brand_id, store_id) => {
      return getters
        .find_stores_by_brand_id(brand_id)
        .find(store => store._id === store_id)
    },
    availableGoorderTypes: (state, getters) => {
      let goorderTypes = {}
      getters.all_goorder_types.forEach(brandOrderType => {
        if (brandOrderType.brands.length) {
          goorderTypes[brandOrderType.name] = brandOrderType
        }
      })
      return goorderTypes
    },
    //delivery options
    availableModules: (state, getters) => {
      let modules = {}
      let allowed = {
        CRM: 'Delivery',
        'Dine-In': 'Dine In',
        'Cashier Apps': 'Carry Out',
      }
      var goorder_type = getters.find_goorder_type_by_main_id(
        state.selectedBusinessType
      )
      if (goorder_type) {
        goorder_type.brands.every(brand_id => {
          var brand = getters.find_brand_by_main_id(brand_id)
          if (brand) {
            var enabled_modules = brand.enabled_modules.filter(
              module => allowed[module]
            )
            enabled_modules.reduce((accum, module) => {
              accum[module] = allowed[module]
              return accum
            }, modules)
            if (Object.keys(modules).length == Object.keys(allowed).length) {
              return false
            }
            return true
          }
          return false
        })
      } else {
        getters.all_brands.every(brand => {
          var enabled_modules = brand.enabled_modules.filter(
            module => allowed[module]
          )
          enabled_modules.reduce((accum, module) => {
            accum[module] = allowed[module]
            return accum
          }, modules)
          if (Object.keys(modules).length == Object.keys(allowed).length) {
            return false
          }
          return true
        })
      }
      return modules
    },
    selectedBrandData: (state, getters) => {
      return getters.find_brand_by_main_id(state.selectedBrandId)
    },
    selectedOffer: state => state.offer,
    timeConvert: () => (time, part) => {
      let timeSplit = time.split(':')
      if (part) {
        return parseInt(timeSplit[0]) * 60 + parseInt(timeSplit[1])
      } else {
        return timeSplit[0]
      }
    },
    getSelectedBusinessTypeShouldHaveKitchen: state =>
      state.selectedBusinessTypeShouldHaveKitchen,
    brandImage: (state, getters) => {
      const brand = getters.currentBrand || getters.selectedBrandData
      let brandImage = ''
      if (brand) {
        brandImage = brand.goorder_background_image
          ? brand.goorder_background_image
          : brand.web_background_image
          ? brand.web_background_image
          : '/images/no-image.jpg'
      }
      return brandImage
    },

    acting_brand: (state, getters) => ({ storeId, brandId }) => {
      //check if store is acting as brand
      let store = getters.currentStore
      let brand = getters.currentBrand

      if (storeId) {
        //get store and its brand
        store = getters.find_store_by_main_id(storeId)
        brand = getters.find_brand_by_main_id(brandId)
      }

      let brandData = {}

      let fieldPrefix = 'goorder'
      //check if in the goorder context
      if (getters.domainBasedBrand) {
        fieldPrefix = 'website'
      }

      if (brand) {
        if (brand[`${fieldPrefix}_multi_brand`]) {
          //is multi brand
          brandData.type = 'store'
          brandData.data = store
          brandData['logo'] =
            store[`${fieldPrefix}_logo`] || brand[`${fieldPrefix}_logo`]
          brandData['background_image'] =
            store[`${fieldPrefix}_background_image`] ||
            brand[`${fieldPrefix}_background_image`]
          brandData['brand_cover'] =
            store[`${fieldPrefix}_brand_cover`] ||
            brand[`${fieldPrefix}_brand_cover`]
          brandData['brand_image'] =
            store[`${fieldPrefix}_brand_image`] ||
            brand[`${fieldPrefix}_brand_image`]
        } else {
          brandData.type = 'brand'
          brandData.data = brand
          brandData['logo'] = brand[`${fieldPrefix}_logo`]
          brandData['background_image'] =
            brand[`${fieldPrefix}_background_image`]
          brandData['brand_cover'] = brand[`${fieldPrefix}_brand_cover`]
          brandData['brand_image'] = brand[`${fieldPrefix}_brand_image`]
        }
      }
      return brandData
    },

    convertDateTimeTimezone: (state, getters) => datetime => {
      // let timeZoneString = getters.getStoreTimezone
      let currentTime = moment(datetime).format('HH:mm')
      let currentDate = moment(datetime).format('YYYY/MM/DD')
      /*if(timeZoneString) {
         currentTime = moment(datetime).tz(timeZoneString).format('HH:mm')
         currentDate = moment(datetime).tz(timeZoneString).format('YYYY/MM/DD')
      }*/
      return { current_time: currentTime, current_date: currentDate }
    },
    quickViewDetails: state => state.quickView,
  },
  actions: {
    async saveCustomization({ state, getters, commit }) {
      return new Promise((resolve, reject) => {
        commit('START_SAVING_CUSTOMIZATION')
        let headers = {}
        if (getters.domainBasedBrand) {
          headers['DomainName'] = location.hostname
        }
        headers['DomainRoot'] = getBaseUrl()
        headers['Content-Type'] = 'application/json'
        let request = {}
        for (let [key, value] of Object.entries(
          state.customizationLocal.colors
        )) {
          let request_key = 'website_' + key
          request[request_key] = value
        }
        request['topbar_availability'] =
          state.customizationLocal.topbar_availability
        request['topbar_logo_position'] =
          state.customizationLocal.topbar_logo_position
        request['slider_availability'] =
          state.customizationLocal.slider_availability
        request['slider_multiimage'] =
          state.customizationLocal.slider_multiimage
        request['title_availability'] =
          state.customizationLocal.title_availability
        request['app_section_availability'] =
          state.customizationLocal.app_section_availability
        request['app_section_image_order'] =
          state.customizationLocal.app_section_image_order
        request['footer_main_availability'] =
          state.customizationLocal.footer_main_availability
        request['footer_sub_availability'] =
          state.customizationLocal.footer_sub_availability

        axios
          .post(
            getters.customization_update_post_request_url,
            JSON.stringify(request),
            {
              headers: headers,
            }
          )
          .then(response => {
            if (response.data.status == 'ok') {
              commit('UPDATE_BASE_CUSTOM_SETTINGS')
              resolve()
            } else {
              if (response.data.form_errors) {
                reject()
              } else {
                reject(response.data.error)
              }
            }
          })
          .catch(error => reject(error))
          .finally(() => commit('STOP_SAVING_CUSTOMIZATION'))
      })
    },
    setBusinessType: ({ commit }, bt) => {
      commit('SET_SELECTED_BUSINESS_TYPE', bt._id)
      if (bt.name.toLowerCase() == 'Restaurant'.toLowerCase()) {
        commit('SET_KITCHEN_NEEDED_FOR_BUSINESS_TYPE', true)
      } else {
        commit('SET_KITCHEN_NEEDED_FOR_BUSINESS_TYPE', false)
      }
    },
    setUIDefaultSettings: ({ commit, getters }) => {
      commit('SET_CUSTOM_SETTINGS', {
        colors: getters.default_colors,
        customization: getters.customization_default,
      })
    },
    setCustomSettings: ({ commit, getters }) => {
      commit('SET_CUSTOM_SETTINGS', {
        colors: getters.current_colors,
        customization: getters.customization,
      })
    },
    updateCustomizationColor: ({ commit }, color) => {
      commit('SET_CUSTOMIZATION_COLOR', color)
    },

    async loadDineinAreas({ getters, commit, dispatch }) {
      commit('SET_ORDER', {})
      await axios.get(`${getters.dine_in_table_area}`).then(resp => {
        commit('SET_DINEIN_AREAS', resp.data.page_lookups.dine_in_area)
        commit('SET_DINEIN_TABLES', resp.data.data)
        let tablse_areas = {
          tables: resp.data.data,
          areas: resp.data.page_lookups.dine_in_area,
        }
        localStorage.setItem('areas_tables', JSON.stringify(tablse_areas))
        dispatch('dineinReservation').then(() => {
          if (getters.currentBrand.number_of_covers) {
            dispatch('loadDineinCovers')
          }
          return Promise.resolve()
        })
      })
    },
    loadDineinCovers({ getters, commit }) {
      axios.get(`${getters.dine_in_covers}`).then(resp => {
        commit('SET_DINEIN_COVERS', resp.data.data)
      })
    },
    _getFloorTableInformation: ({ dispatch, commit }, floorTable) => {
      localStorage.setItem(
        'getFloorTableInformation',
        JSON.stringify(floorTable)
      )
      commit('SET_SELECTED_DELIVERY_OPTION', 'Dine-In')
      dispatch('loadDineinAreas').then(() => {
        return Promise.resolve()
      })
    },
    notifyStoreAboutTable: ({ commit, getters }, data) => {
      if (getters.isFloorTableAvailable.table_id) {
        data.table_no = getters.dineinTable(
          getters.isFloorTableAvailable.table_id
        ).number
        data.area = getters.dineinArea(
          getters.isFloorTableAvailable.floor_id
        ).name
        data.order_type = CONST.ORDER_TYPE_DINEIN
      }
      data.order_no = getters.track_order_data.order_no
      commit('DINE_IN_NOTIFY', data.message + '...')
      return new Promise((resolve, reject) => {
        let headers = {}
        if (getters.domainBasedBrand) {
          headers['DomainName'] = location.hostname
        }
        headers['DomainRoot'] = getBaseUrl()
        headers['Content-Type'] = 'application/json'
        axios
          .post(getters.notify_store_dine_in, data, {
            headers: headers,
          })
          .then(response => {
            if (response.data.status == 'ok') {
              commit(
                'DINE_IN_NOTIFY',
                'Notified to store, they will respond you soon.'
              )
              resolve()
            } else {
              commit(
                'DINE_IN_NOTIFY',
                'Sorry!! something went wrong please try again.'
              )
              if (response.data.form_errors) {
                reject()
              } else {
                reject(response.data.error)
              }
            }
          })
          .catch(error => {
            commit(
              'DINE_IN_NOTIFY',
              'Sorry! something went wrong please try again.'
            )
            reject(error)
          })
      })
    },
  },
  mutations: {
    SET_DOMAIN_BASED_CUSTOM_SETTINGS: (state, current_brand) => {
      if (current_brand) {
        Vue.set(
          state.customization,
          'topbar_availability',
          current_brand['topbar_availability']
        )
        Vue.set(
          state.customization,
          'topbar_logo_position',
          current_brand['topbar_logo_position']
        )
        Vue.set(
          state.customization,
          'slider_availability',
          current_brand['slider_availability']
        )
        Vue.set(
          state.customization,
          'slider_multiimage',
          current_brand['slider_multiimage']
        )
        Vue.set(
          state.customization,
          'title_availability',
          current_brand['title_availability']
        )
        Vue.set(
          state.customization,
          'app_section_availability',
          current_brand['app_section_availability']
        )
        Vue.set(
          state.customization,
          'app_section_image_order',
          current_brand['app_section_image_order']
        )
        Vue.set(
          state.customization,
          'footer_main_availability',
          current_brand['footer_main_availability']
        )
        Vue.set(
          state.customization,
          'footer_sub_availability',
          current_brand['footer_sub_availability']
        )
      } else {
        state.customization = state.customization_default
      }
    },
    DINE_IN_NOTIFY: (state, message) => {
      state.dineinNotify = message
    },
    STOP_SAVING_CUSTOMIZATION: state => {
      state.customizationIsSaving = false
    },

    START_SAVING_CUSTOMIZATION: state => {
      state.customizationIsSaving = true
    },
    SET_CUSTOMIZATION_COLOR: (state, color) => {
      Vue.set(
        state.customizationLocal.colors,
        color.color_name,
        color.color_value
      )
    },
    SET_CUSTOM_SETTINGS: (state, values) => {
      Vue.set(
        state.customization,
        'colors',
        JSON.parse(JSON.stringify(values.colors))
      )
      state.customizationLocal = JSON.parse(
        JSON.stringify(values.customization)
      )
      Vue.set(
        state.customizationLocal,
        'colors',
        JSON.parse(JSON.stringify(values.colors))
      )
      utils.applyColoring()
    },
    UPDATE_BASE_CUSTOM_SETTINGS: state => {
      state.customization = JSON.parse(JSON.stringify(state.customizationLocal))
    },
    SET_MOBILE_MODIFIER: state => {
      state.openModifierMobile = !state.openModifierMobile
    },
    SET_ITEM_DETAIL_POPUP: (state, openModifier = false) => {
      state.openModifier = openModifier
    },
    PRODUCT_DETAILS_PAGE: (state, status = false) => {
      state.productDetailsPage = status
    },
    SET_PRODUCT_ID: (state, product_id = undefined) => {
      state.productId = product_id
    },

    SET_DINEIN_FLOOR_TABLE: (
      state,
      floorTable = { table_id: undefined, floor_id: undefined }
    ) => {
      state.floorTable = floorTable
    },

    SET_DINEIN_AREAS: (state, dinein_areas = undefined) => {
      state.dineinAreas = dinein_areas
    },

    SET_DINEIN_TABLES: (state, dinein_tables = undefined) => {
      state.dineinTables = dinein_tables
    },

    SET_DINEIN_COVERS: (state, dinein_covers = undefined) => {
      state.dineinCovers = dinein_covers
    },
    SET_SELECTED_BUSINESS_TYPE: (state, businessType) => {
      state.selectedBusinessType = businessType
    },
    SET_KITCHEN_NEEDED_FOR_BUSINESS_TYPE: (state, value) => {
      state.selectedBusinessTypeShouldHaveKitchen = value
    },
    SET_SELECTED_GOORDER_TYPE: (state, goorderType) => {
      state.selectedType = goorderType
    },
    SET_SELECTED_DELIVERY_OPTION: (state, option) => {
      state.selectedDelivery = option
    },
    SET_SELECTED_KITCHEN_TYPE: (state, kitchenType) => {
      state.selectedKitchenType = kitchenType
    },
    SET_SELECTED_RADIUS: (state, radius) => {
      state.selectedRadis = radius
    },
    SET_SELECTED_PRICE_RANGE: (state, priceRange) => {
      state.selectedPriceRange = priceRange
    },
    SET_SELECTED_BRAND: (state, brand_id) => {
      state.selectedBrandId = brand_id || false
    },
    SET_SEARCH_TERM: (state, term) => (state.searchTerm = term),
    QUICK_VIEW: (state, quickView) => {
      state.quickView = quickView
      state.quickLoader = !quickView.items || true
    },
    SET_SELECTED_OFFER: (state, offer) => (state.offer = offer),
  },
}
